module.exports = __webpack_public_path__ + "static/media/OldManInADingyNightCafe.ffedb441.jpg";